/* eslint-disable react-hooks/exhaustive-deps */
import { ReactNode, useEffect, useState } from 'react';

import styled from 'styled-components';
import { isLoggedInApi } from './../apis/index';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/Admin/Loader';

interface Props {
  children: ReactNode;
}

const PrivateLayout = ({ children }: Props) => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleIsLoggedIn = async () => {
    try {
      await isLoggedInApi();
      setIsLoading(false);
    } catch (error: any) {
      navigate('/admin');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleIsLoggedIn();
  }, []);

  return (
    <>
      {!isLoading ? (
        <>
          <Wrapper>{children}</Wrapper>
        </>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default PrivateLayout;

const Wrapper = styled.div`
  min-height: 100vh;
`;
